<template>
	<div>
	  <div class="red_top_bg">
		<div
		  class="back_left"
		  @click="$router.back()"
		/>
		<div class="big_tit">
		  {{ $t('pagea.jfdh') }}
		</div>
	  </div>
	  <div style="padding: 10px;">
		  <div class="data_item" v-if="info.img">
			  <img :src="info.img" style="width: 110px;"/>
			  <div style="margin-left: 10px;">
				  <div> {{ info[lang] }}</div>
				  <div style="margin-top: 20px;"> {{ info.num }}<span style="margin-left: 5px;">{{ $t('pagea.jf') }}</span></div>
			  </div>
		  </div>
		  <div class="add_wrap">
			<van-form @submit="onSubmit">
				<van-field v-model="dz_name" :label="$t('pagea.shr')" :placeholder="$t('pagea.shr')" required
				type="text"
				maxlength="30"
				    :rules="[{ required: true, message: '' }]"
				/>
				<van-field v-model="dz_phone" type="number" :label="$t('pagea.lxdh')" :placeholder="$t('pagea.lxdh')" required
				    :rules="[{ required: true, message: '' }]"/>
				<van-field v-model="dz_address" :label="$t('pagea.xxdz')" 
					:placeholder="$t('pagea.xxdz')"   
					type="textarea" rows="3" required
					maxlength="150"
				    :rules="[{ required: true, message: '' }]"/>
				<div style="margin-top: 30px;">
					<van-button type="danger" block round native-type="submit">{{ $t('pagea.tjdd') }}</van-button>
				</div>
			</van-form>

			  <div style="text-align: center;padding: 20px 0;">{{ $t('pagea.xh') }}<span style="margin-left: 5px;">{{ $t('pagea.jf') }}</span>：<span class="score_txt">{{ info.num }}</span></div>
		  </div>
	  </div>
	  
	</div>
</template>

<script>
    import Fetch from '../../utils/fetch'
	import Vue from 'vue';
	import { Form } from 'vant';
	import { Field } from 'vant';

	import { Toast } from 'vant';
	
	import { Button } from 'vant';
	
	Vue.use(Button);
	Vue.use(Form);
	
	Vue.use(Field);

	
	export default{
		data(){
			return{
				info:{},
				lang:this.$i18n.locale||"zh_cn",
				dz_name:"",
				dz_phone:"",
				dz_address:"",
			}
		},
        created() {
            this.$parent.footer('user', false);
        },
		mounted() {
			this.getdata();
		},
		methods:{
			onSubmit() {
				let formdata={
					id: this.$router.history.current.params.id,
					goodname_lang:this.info[this.lang],
					dz_name:this.dz_name,
					dz_phone:this.dz_phone,
					dz_address:this.dz_address,
				};
				let self=this;
				Fetch('/index/saveorder', formdata).then((res) => {
					let result=res.data;
					if(res.info!='jifenbuzu'){
						self.$router.push("/mygoods");
					}else{
						Toast(self.$t('pagea.jfbz'))
					}
				});
			},
			getdata(){
				let self=this;
				Fetch('/index/goodsdetail', {id: this.$router.history.current.params.id}).then((res) => {
					let result=res.data;
					this.info=result;
				});
			},
		}
	}
	
</script>

<style lang="less" scoped>
	.score_txt{
		    font-size: 20px;
		    color: rgb(255, 55, 55);
	}
	.data_item{
		display: flex;
		align-items: center;
		color: #000;
		font-size:16px;
		background-color: #fff;
		border-radius: 12px;
	}
	.add_wrap{
		color: #000;
		font-size:16px;
		background-color: #fff;
		border-radius: 12px;
		margin-top: 10px;
		padding:10px;
	}
</style>